import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { useCallback } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { getNumberRange, isNil } from 'shared/src/utils';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';

export const useLogClickMarket = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const { data: goodsBasic } = useGoodsBasic();
  const { data: goodsDetail } = useGoodsDetail();

  return useCallback(() => {
    if (isNil(goodsBasic)) return;
    if (isNil(goodsDetail)) return;

    logGoodsAnalytics({
      name: 'CLICK_MARKET',
      analytics: {
        AGE_TAG1: goodsBasic.market.age_tags[0],
        AGE_TAG2: goodsBasic.market.age_tags[1],
        FAVORITE_COUNT: goodsDetail.goods.market.score.favorites_count,
        FAVORITE_COUNT_RANGE: getNumberRange({
          rangeUnit: 500,
          target: goodsDetail.goods.market.score.favorites_count,
        }),
        IS_FAVORITED: goodsDetail.goods.market.is_favorite ?? false,
        LIKE_COUNT: goodsDetail.goods.score.likes_count,
        LIKE_COUNT_RANGE: getNumberRange({
          rangeUnit: 500,
          target: goodsDetail.goods.market.score.favorites_count,
        }),
        STYLE_TAG1: goodsBasic.market.style_tags[0],
        STYLE_TAG2: goodsBasic.market.style_tags[1],
        TYPE: 'SIMPLE',
      },
    });
  }, [goodsBasic, goodsDetail, logGoodsAnalytics]);
};
